import axios from "axios"
import { useEffect, useState } from "react"
import { Fade } from "react-awesome-reveal"
import PageLoader from "../../components/global/loader/PageLoader";
import { InternalBanner } from "../../components/internals/InternalBanner"
import ImgFormAvatar from './../../assets/img_form_avatar.png';
import './styles.scss';

export const ContactUs = () => {
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);
    const [globalOptions, setGlobalOptions] = useState(null);
     const [isSucceed, setIsSucceed] = useState(false);
const [fullName, setFullName] = useState('');
const [phone, setPhone] = useState('');
const [email, setEmail] = useState('');
const [message, setMessage] = useState('');
const [isFetching, setIsFetching] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);

useEffect(() => {
    document.getElementById('phone_1').addEventListener('input', function (e) {
        var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        setPhone(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
    });
}, []);

const onSubmitForm = async (e) => {

    e.preventDefault();
    setIsSubmitting(true);

    try {
        await axios.post(
            '/wp-json/gf/v2/forms/1/submissions', // Replace {form_id} with your actual Gravity Form ID
            {
                'input_1': fullName,
                'input_3': email,
                'input_4': phone,
                'input_5': message,
                'input_6': window.location.href,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
        );

        setFullName('');
        setPhone('');
        setEmail('');
        setMessage('');
        setIsSucceed(true);
    } catch (err) {
        console.log(err);
    } finally {
        setIsSubmitting(false);
    }
    return false;
}
    useEffect(() => {
        fetchGlobalOptions();
        fetchPageContent();
        document.getElementById('root').classList.add('contact-us-page');
        return (() => {
            document.getElementById('root').classList.remove('contact-us-page');
        });
    }, []);

    const fetchGlobalOptions = async () => {
      try {
        const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_global_site_options");
        setGlobalOptions(data);
      } catch (e) {
        setGlobalOptions(null);
      }
    }

    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=contact_us`);
            setPageContent(data);
            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Contact - Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    console.log(globalOptions); 

    return <Fade delay={1}>
        <main id="main" className="internal-page">
            {!isFetching && !isFetchingPageData && <>
            
                <InternalBanner page={{ post_title: "Contact Us"}} />
                <section id="contact-us-form-wrapper">
                    <div className="footer-form-wrapper">
                        <div className="form-wrapper">
                            <div className="footer-form-heading">
                                <span className="form-title">
                                    Get a Free Consultation.
                                </span>
                                <img src={ImgFormAvatar} />
                                <span className="form-description">
                                    Hi, this is Joe, founder of JTM Jr. & Associates.
                                    We would love to connect and provide a free consultation
                                </span>
                                {
                                    isSucceed && <span className='succeed'>Form submitted successfully!</span>
                                }
                            </div>
                            <form id="footer-form" onSubmit={onSubmitForm}>
                                <div className="form-fields">
                                    <div className="field">
                                        <input 
                                            type="text" 
                                            name="name" 
                                            id="name" 
                                            placeholder="Name" 
                                            required 
                                            value={fullName}
                                            onChange={(e) => {
                                                setFullName(e?.target?.value ?? "")
                                            }}
                                        />
                                    </div>
                                    <div className="field">
                                        <input 
                                            type="email" 
                                            name="email" 
                                            id="email" 
                                            placeholder="Email" 
                                            required
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e?.target?.value ?? "");
                                            }}
                                        />
                                    </div>
                                    <div className="field">
                                        <input
                                            type="phone" 
                                            name="phone_1" 
                                            id="phone_1" 
                                            placeholder="Phone" 
                                            value={phone}
                                            onChange={(e) => {
                                                setPhone(e?.target?.value ?? "")
                                            }}
                                            required 
                                        />
                                    </div>
                                    <div className="field">
                                        <textarea 
                                            name="message" 
                                            id='message' 
                                            placeholder="Tell us about your case"
                                            value={message}
                                            required
                                            onChange={(e) => {
                                                setMessage(e?.target?.value ?? "")
                                            }}
                                        />
                                    </div>
                                </div>
                                <button type="submit" className={`button ${isSubmitting ? 'disabled' : ''}`}>
                                    { isSubmitting ? 'Submitting...' : 'Make an appointment'}
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className='features-wrapper'>
                        <div className='features-repeater'>
                            {
                                globalOptions?.stats?.map((it, index) => <div className='block-feature-item' key={index}>
                                    <h3 dangerouslySetInnerHTML={{ __html: it?.block_value }}></h3>
                                    <span className='details'>{it?.block_details}</span>
                                </div>)
                            }
                        </div>
                    </div>
                </section>
                <section id="contact-us-page-wrapper">
                    <div className="container">
                        <article dangerouslySetInnerHTML={{__html: pageContent?.page?.post_content}} />
                    </div>
                </section>
            </>}

            {
                (isFetching || isFetchingPageData) && <PageLoader />
            }
            
        </main>
    </Fade>
}